var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus","size":"small"},on:{"click":function($event){return _vm.openDialog('add')}}},[_vm._v("新 增")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }